import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const headingSettings = {
  ...commonDefaultSettings,
  heading: 'Heading',
  caption: ''
};
